import { IssuerId } from "@goodfill/domain-properties";
import { PricedBond } from "../../PricedBond";

export function createIndexOfBondsPerIssuer(pricedBonds: PricedBond[]): Map<IssuerId, PricedBond[]> {
  return pricedBonds.reduce((result, pricedBond) => {
    const issuerId = pricedBond.issuerId;

    let resultItem = result.get(issuerId);
    if (resultItem === undefined) {
      resultItem = [];
      result.set(issuerId, resultItem);
    }

    resultItem.push(pricedBond);

    return result;
  }, new Map<IssuerId, PricedBond[]>());
}
